import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/zh-TW.ts
var add = "新增";
var remove = "移除";
var removeAll = "移除全部";
var incomplete = "很抱歉，部分欄位填寫錯誤";
var submit = "提交";
var noFiles = "尚未選取檔案";
var moveUp = "上移";
var moveDown = "下移";
var isLoading = "載入中...";
var loadMore = "載入更多";
var next = "下一個";
var prev = "上一個";
var addAllValues = "加入全部的值";
var addSelectedValues = "加入選取的值";
var removeAllValues = "移除全部的值";
var removeSelectedValues = "移除選取的值";
var chooseDate = "選擇日期";
var changeDate = "變更日期";
var close = "關閉";
var open = "開放";
var accepted = function({
  name
}) {
  return `請接受 ${name}`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} 必須晚於 ${date(args[0])}`;
  }
  return `${sentence(name)} 必須晚於今日`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} 欄位儘能填寫英文字母`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} 欄位僅能填寫英文字母與數字`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} 欄位儘能填寫英文字母與空白`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} 必須早於 ${date(args[0])}.`;
  }
  return `${sentence(name)} 必須早於今日`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `欄位值錯誤，無法提交`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} 必須介於 ${a} 和 ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} 與目標不一致`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} 不是有效的日期，請使用 ${args[0]} 格式`;
  }
  return "欄位值錯誤，無法提交";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} 必須介於 ${date(args[0])} 和 ${date(args[1])}`;
};
var email = "請輸入有效的 email";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} 的結尾必須是 ${list(args)}`;
};
var is = function({
  name
}) {
  return `${sentence(name)} 欄位的值不合規則`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} 欄位必須至少包含一個字`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} 的字數必須小於等於 ${max2}`;
  }
  if (min2 === max2) {
    return `${sentence(name)} 的字數必須為 ${max2}`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} 的字數必須大於等於 ${min2}`;
  }
  return `${sentence(name)} 的字數必須介於 ${min2} 和 ${max2}`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} 欄位的值無效`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `不能超過 ${args[0]} 個 ${name}.`;
  }
  return `${sentence(name)} 必須小於等於 ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "非有效的檔案格式";
  }
  return `${sentence(name)} 可接受的檔案格式為: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `不可少於 ${args[0]} 個 ${name}`;
  }
  return `${name} 必須大於等於 ${args[0]}`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” 不是 ${name} 欄位可接受的值`;
};
var number = function({
  name
}) {
  return `${sentence(name)} 欄位必須是數字`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join("或")}${labels}需要。`;
};
var required = function({
  name
}) {
  return `${sentence(name)} 是必要欄位`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} 的開頭必須是 ${list(args)}`;
};
var url = function() {
  return `請輸入有效的 url`;
};
var invalidDate = "選取的日期無效";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var zh_TW_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, date_after, date_before, date_between, date_format, zh_TW_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=zh-TW.mjs.map